// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__9gcDc","text":"style_text__GlrEl","remove":"style_remove__LKSMe"};